import React from 'react'
import { AppRoute } from '@chegg-wt/core/types/core'
import AppLink from '../AppLink'
import * as Styled from './styled'

export interface BreadcrumbPart {
  label: string
  route?: AppRoute
  last?: boolean
}

interface BreadcrumbsProps {
  /**
   * parts requires at least 2 items, as the last item should be a label for the current page
   */
  parts: BreadcrumbPart[]
  divider?: string
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ parts, divider = '/' }) => (
  <Styled.BreadcrumbContainer>
    {parts.length > 1 &&
      parts.map(({ label, route, last }) => (
        <Styled.CrumbWrapper key={label}>
          {route && !last && (
            <>
              <AppLink route={route}>
                <Styled.CrumbLink>{label}</Styled.CrumbLink>
              </AppLink>
              <Styled.CrumbDivider>{divider}</Styled.CrumbDivider>
            </>
          )}
          {(!route || last) && <Styled.CrumbLabel>{label}</Styled.CrumbLabel>}
        </Styled.CrumbWrapper>
      ))}
  </Styled.BreadcrumbContainer>
)
